var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Контакти","resource":"crm-contacts","columns":_vm.columns,"get-items-fn":_vm.getContacts}})}
var staticRenderFns = []

export { render, staticRenderFns }